import qs from "qs";
import { createBrowserHistory } from "history";
const history = createBrowserHistory();

const queryToObj = () => {
    let { location } = history;

    if (location.search.length > 0) {
        const search = location.search.substring(1);
        const query = qs.parse(search);
        location = Object.assign(location, { query, queryString: location.search, search: query });
    } else {
        location = Object.assign(location, { query: {}, queryString: "", search: {} });
    }
};

Object.defineProperty(history, "decideGoBack", {
    value: function decideGoBack() {
        // key check is kept as when user have a active session and login from mail in another tab , then goBack do not works.
        const { key = "" } = history.location;
        if (key) {
            history.go(-1);
        } else {
            history.replace("/dashboard");
        }
    }
});

history.listen(() => {
    queryToObj();
});

// When we refresh the browser
queryToObj();

export default history;
